module.exports = __webpack_public_path__ + "img/align-vertically.e7a9b5d4.svg";